import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Alert, TabsPanel } from '@dev/ee-components';
import { useIsTypeAB } from '@/components/CampaignCreator/hooks/useIsTypeAB';
import { CampaignErrorNames, CampaignErrors } from '@/store/campaignCreator/types';
import { getCampainCreatorStore, SetActiveUtmTabIndex } from '@/store/campaignCreator/actions';
import { INDEX_PLACEHOLDER } from '@/services/constants';
import { useCampaignScreensPathsChecker } from '../../../../../../hooks/useCampaignScreensPathsChecker';
import { UTMWrapper, AlertWrapper, ManageIpsTabsWrapper } from './styles';
import UTMInputs from './components/UTMInputs';

const sourceErrorName = (index: string | number): string =>
    CampaignErrorNames.CAMPAIGN_TEMPLATES_UTM_SOURCE.replace(INDEX_PLACEHOLDER, `${index}`);
const mediumErrorName = (index: string | number): string =>
    CampaignErrorNames.CAMPAIGN_TEMPLATES_UTM_MEDIUM.replace(INDEX_PLACEHOLDER, `${index}`);
const campaginErrorName = (index: string | number): string =>
    CampaignErrorNames.CAMPAIGN_TEMPLATES_UTM_CAMPAIGN.replace(INDEX_PLACEHOLDER, `${index}`);
const contentErrorName = (index: string | number): string =>
    CampaignErrorNames.CAMPAIGN_TEMPLATES_UTM_CONTENT.replace(INDEX_PLACEHOLDER, `${index}`);

const tabHasError = (errors: CampaignErrors, index: number): boolean =>
    !!errors?.[sourceErrorName(index)] ||
    !!errors?.[mediumErrorName(index)] ||
    !!errors?.[campaginErrorName(index)] ||
    !!errors?.[contentErrorName(index)];

export const UTMSection = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isTypeAB = useIsTypeAB();
    const { abTabs, errors, activeUtmTabIndex } = useSelector(getCampainCreatorStore);
    const { isDetailsScreen } = useCampaignScreensPathsChecker();

    const onTabChange = (event: React.ChangeEvent<HTMLElement>, value: string | number): void => {
        dispatch(SetActiveUtmTabIndex(parseInt(value as string, 10)));
    };

    return (
        <UTMWrapper>
            {!isDetailsScreen && (
                <AlertWrapper>
                    <Alert severity="info" body={t('utmparametersinfo')} />
                </AlertWrapper>
            )}
            {isTypeAB && (
                <ManageIpsTabsWrapper>
                    <TabsPanel
                        isMobile={false}
                        value={`${activeUtmTabIndex}`}
                        onChange={onTabChange}
                        tabs={abTabs.map((item, index) => ({
                            label: item.tabTitle,
                            value: item.id,
                            hasError: tabHasError(errors, index),
                        }))}
                        defaultUseTabsValues
                        disableSentenceCase
                    />
                </ManageIpsTabsWrapper>
            )}
            <UTMInputs
                index={activeUtmTabIndex}
                sourceErrorName={sourceErrorName(activeUtmTabIndex)}
                mediumErrorName={mediumErrorName(activeUtmTabIndex)}
                campaginErrorName={campaginErrorName(activeUtmTabIndex)}
                contentErrorName={contentErrorName(activeUtmTabIndex)}
            />
        </UTMWrapper>
    );
};
